// theme.ts
import {
    Button,
    Card,
    colorsTuple,
    createTheme,
    DEFAULT_THEME,
    Loader,
    mergeMantineTheme,
    Tabs,
    TabsPanel,
    virtualColor,
} from '@mantine/core';
import {generateColors} from '@mantine/colors-generator';
import './styles/theme.css';

const themeOverride = createTheme({
  primaryColor: 'primaryColor',

  other: {
    smoothScroll: true,
  },

  colors: {
    // Creating colors for light / dark mode
    primaryColor: virtualColor({
      name: 'primaryColor',
      dark: 'lightGray',
      light: 'blue',
    }),
    bodyBackgroundColor: virtualColor({
      name: 'bodyBackgroundColor',
      dark: 'darkBodyGray',
      light: 'fixedLightGray',
    }),
    whiteBackgroundColor: virtualColor({
      name: 'whiteBackgroundColor',
      dark: 'darkBodyGray',
      light: 'white',
    }),
    sidebarBackgroundColor: virtualColor({
      name: 'sidebarBackgroundColor',
      dark: 'dark',
      light: 'sidebarBlue',
    }),

    sectionColor: virtualColor({
      name: 'sectionColor',
      dark: 'darkGray',
      light: 'fixedLightGray',
    }),

    sectionColorVariant: virtualColor({
      name: 'sectionColorVariant',
      dark: 'darkDarkBlue',
      light: 'lightBlue',
    }),
    fontColor: virtualColor({
      name: 'fontColor',
      dark: 'gray',
      light: 'black',
    }),

    headerColor: virtualColor({
      name: 'headerColor',
      dark: 'dark.6',
      light: 'darkBlue',
    }),

    // Adding new colors and replacing existing colors from DefaultMantineColor
    white: colorsTuple('#FFFFFF'),

    orangeRed: generateColors('#D33703'),

    lightBlue: colorsTuple('#d4ebf5'),
    darkBlue: generateColors('#253342'),
    darkDarkBlue: colorsTuple('#1A202C'),
    blue: generateColors('#175da6'),
    sidebarBlue: colorsTuple('#3c4b64'),

    fixedLightGray: colorsTuple('#f5f5f5'),
    lightGray: generateColors('#c6c6c6'),
    gray: generateColors('#545454'),
    darkGray: colorsTuple('#202020'),
    darkBodyGray: colorsTuple('#2e2e2e'),

    orange: generateColors('#f2643b'),

    // Adding semantic colors
    danger: generateColors('#fa5252'),
    success: generateColors('#51cf66'),
    warning: generateColors('#f59f00'),
  },

  primaryShade: {
    light: 6,
    dark: 8,
  },

  fontFamily: 'Roboto, sans-serif',

  components: {
    Tabs: Tabs.extend({
      defaultProps: {
        variant: 'outline',
      },
    }),

    TabsPanel: TabsPanel.extend({
      defaultProps: {
        bg: 'whiteBackgroundColor',
        p: 'md',
        style: {
          borderRadius: '3px',
          borderLeft: '1px solid var(--tab-border-color)',
          borderRight: '1px solid var(--tab-border-color)',
          borderBottom: '1px solid var(--tab-border-color)',
        },
      },
    }),

    Card: Card.extend({
      defaultProps: {
        mb: 'md',
        withBorder: true,
        shadow: 'sm',
      },
    }),
    Loader: Loader.extend({
      defaultProps: {
        loaders: { ...Loader.defaultLoaders },
        type: 'bars',
        color: 'blue',
      },
    }),
    Button: Button.extend({
      defaultProps: {
        color: 'blue',
        variant: 'filled',
      },
    }),
    AppShell: {
      defaultProps: {
        padding: 'md',
        shadow: 'xs',
      },
    },
  },
});

export const theme = mergeMantineTheme(DEFAULT_THEME, themeOverride);
